import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const HEADERS = { Accept: 'application/ld+json' };

/** Émis quand le nombre de nouveautés non lues change (sidebar, page). */
export const PATCH_NOTES_CHANGED = 'spot:patch-notes-changed';

export function notifyPatchNotesChanged() {
    window.dispatchEvent(new Event(PATCH_NOTES_CHANGED));
}

export function hydraMembers(res) {
    const d = res?.data;
    if (Array.isArray(d)) return d;
    return d?.['hydra:member'] || d?.member || [];
}

export function iriId(ref) {
    if (!ref) return null;
    if (typeof ref === 'object') return ref.id != null ? Number(ref.id) : null;
    const m = String(ref).match(/\/(\d+)$/);
    return m ? Number(m[1]) : null;
}

const jsonLd = {
    withCredentials: true,
    headers: HEADERS,
    params: { pagination: false },
};

export async function fetchPublishedPatchNotes() {
    const res = await axios.get(`${API_URL}/patch_notes`, {
        ...jsonLd,
        params: { pagination: false, publie: true },
    });
    const notes = hydraMembers(res).filter((p) => p.publie);
    notes.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    return notes;
}

export async function fetchReadPatchIds(userId) {
    if (!userId) return [];
    const res = await axios.get(`${API_URL}/patch_note_reads`, {
        ...jsonLd,
        params: { pagination: false, user: `/api/users/${userId}` },
    });
    const reads = hydraMembers(res).filter((r) => iriId(r.user) === Number(userId));
    return reads.map((r) => iriId(r.patchNote)).filter((id) => id != null);
}

export async function fetchUnreadPatchCount(userId) {
    const [notes, readIds] = await Promise.all([
        fetchPublishedPatchNotes(),
        fetchReadPatchIds(userId),
    ]);
    return notes.filter((n) => !readIds.includes(n.id)).length;
}

export async function markPatchNoteRead(userId, patchNoteId) {
    await axios.post(`${API_URL}/patch_note_reads`, {
        user: `/api/users/${userId}`,
        patchNote: `/api/patch_notes/${patchNoteId}`,
    }, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/ld+json', Accept: 'application/ld+json' },
    });
    notifyPatchNotesChanged();
}

export function previewText(contenu, max = 140) {
    const text = (contenu || '').replace(/\s+/g, ' ').trim();
    if (text.length <= max) return text;
    return `${text.slice(0, max).trim()}…`;
}

export function authorName(note) {
    if (!note?.createdBy) return null;
    const name = `${note.createdBy.prenom || ''} ${note.createdBy.nom || ''}`.trim();
    return name || null;
}
